<script setup>
import { useAttrs, useListeners } from 'vue';

const attrs = useAttrs();
const listeners = useListeners();
</script>

<template>
  <button
    data-component="CsListboxBottomItem"
    class="flex items-center cursor-pointer text-sm gap-1 py-1.5 px-3 rounded-b-lg hover:bg-brand-black-alpha-5 active:bg-brand-black-alpha-7 text-brand-blue-11 hover:text-brand-blue-12"
    v-bind="attrs"
    v-on="listeners"
  >
    <slot />
  </button>
</template>
